// Module
var code = "<div layout=\"row\" class=\"full-height\" ng-mouseenter=\"$ctrl.onEnter()\" ng-mouseleave=\"$ctrl.onLeave()\"> <span bringoz-ppi class=\"br-body-2 margin-left-5\">{{$ctrl.phone | bringozPhone}}</span> <text-copy-button ng-if=\"!!$ctrl.textToCopy\" text=\"$ctrl.textToCopy\"></text-copy-button> </div> ";
// Exports
export default code;